(function () {
  function initStickyCta() {
    var cta = document.querySelector('[data-sp-founder-sticky-cta]');
    var closing = document.querySelector('[data-sp-founder-closing-cta]');
    if (!cta || cta.dataset.spFounderReady === 'true') return;
    cta.dataset.spFounderReady = 'true';
    var showAt = Number(cta.getAttribute('data-show-at') || 500);
    function update() {
      var scrolled = window.scrollY > showAt;
      var nearClosing = false;
      if (closing) {
        var rect = closing.getBoundingClientRect();
        nearClosing = rect.top < window.innerHeight - 80;
      }
      cta.classList.toggle('is-visible', scrolled && !nearClosing);
      cta.setAttribute('aria-hidden', scrolled && !nearClosing ? 'false' : 'true');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initReviewCarousels(root) {
    (root || document).querySelectorAll('[data-sp-founder-reviews]').forEach(function (section) {
      var track = section.querySelector('[data-sp-founder-reviews-track]');
      var prev = section.querySelector('[data-sp-founder-reviews-prev]');
      var next = section.querySelector('[data-sp-founder-reviews-next]');
      if (!track || !prev || !next || track.dataset.spFounderReady === 'true') return;
      track.dataset.spFounderReady = 'true';
      function step() {
        var card = track.querySelector('.v2-review-card');
        if (!card) return 320;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
        return card.getBoundingClientRect().width + gap;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  function init(root) {
    initStickyCta();
    initReviewCarousels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
